module.exports = __webpack_public_path__ + "static/media/FilterAdjust.0233a61f.svg";